<template>
  <div style="width:100%">
      <v-row  style="margin-top:20px;">
          <v-col cols="12" sm="12" md="9" lg="9">
            <div class="sub-title">Overview Report</div>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-row >
              <v-col cols="12">
                <v-select
                  :items="filterUsers"
                  item-value="id"
                  item-text="name"
                  label="Filter"
                  v-model="selectedFilter"
                  solo
                  @change="search"
                ></v-select>
              </v-col>
              <!-- <v-col cols="12" sm="12" md="3" lg="3" style="margin-top:10px;">
                <v-btn small color="secondary" @click="clearFilter">Clear</v-btn>
              </v-col> -->
            </v-row>
          </v-col>
          <hr style="width: 100%; color:rgba(0,0,0,0.12);margin-top:0px;" />
      </v-row>
      <v-row>
          <v-col cols="12" sm="12">
              <!--
                Multiple Layered Data Table (Three Layers)
                --------if client group-------
                Group Lists
                |__ Clients Lists
                  |___Campaign Lists

                --------if no group-------
                |__ Client Lists
                  |___Campaign Lists
               -->
              <v-data-table
                :headers="overviewHeaders"
                :items="overviewData"
                single-expand
                :expanded.sync="expanded"
                :key="dataTableKey"
                class="elevation-1"
                show-expand
              >
                  <template v-slot:[`item.name`]="{ item }">
                    <v-icon v-if="item.type === 'group'">mdi-domain</v-icon> {{item.name}}
                  </template>
                  <template v-slot:[`item.totalIOAmount`]="{ item }">
                      <v-chip class="ma-1" color="primary" small text-color="white">
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                        <span>{{ item.totalIOAmount | thousandSeprator}}</span>
                      </v-chip>
                  </template>
                  <template v-slot:[`item.totalRevenue`]="{ item }">
                      <v-chip class="ma-1" color="green" small text-color="white">
                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                        <span>{{ item.totalRevenue | thousandSeprator}}</span>
                      </v-chip>
                  </template>

                  <template v-slot:[`item.totalCompletion`]="{ item }">
                      <div :style="{color: getColor(item.totalCompletion)}">{{ item.totalCompletion }} %</div>
                  </template>
                  <template v-slot:[`item.totalPayout`]="{ item }">
                    <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.totalPayout | thousandSeprator}}
                  </template>
                  <template v-slot:[`item.lastIODate`]="{ item }">
                      <div>{{ formatDate(item.lastIODate) }} </div>
                  </template>

                  <template v-slot:[`item.CO`]="{ item }">
                      <v-chip
                        class="ma-1"
                        small
                        v-for="(obj, index) in item.CO"
                        :key="index"
                      >
                          {{ obj.firstName }}
                      </v-chip>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }" style="box-shadow:none;">
                    <td :colspan="headers.length" style="border:none;padding:20px;" v-if="item.campaigns">
                      <v-data-table
                        :headers="detailsHeaders"
                        :items="item.campaigns"
                        class="elevation-1"
                        hide-default-footer
                      >
                        <template v-slot:[`item.IOAmount`]="{ item }">
                          <span v-if="item.IOAmount === 0">N/A</span>
                          <v-chip class="ma-1" color="primary" small text-color="white" v-else>
                            <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                            <span>{{ item.IOAmount | thousandSeprator}}</span>
                          </v-chip>
                        </template>
                        <template v-slot:[`item.budget`]="{ item }">
                          <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.budget | thousandSeprator}}
                        </template>
                        <template v-slot:[`item.payout`]="{ item }">
                          <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.payout | thousandSeprator}}
                        </template>
                        <template v-slot:[`item.revenvue`]="{ item }">
                            <v-chip class="ma-1" color="green" small text-color="white">
                              <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                              <span>{{ item.revenvue | thousandSeprator}}</span>
                            </v-chip>
                        </template>
                        <template v-slot:[`item.completion`]="{ item }">
                            <div :style="{color: getColor(item.completion)}">{{ item.completion }}</div>
                        </template>
                        <template v-slot:[`item.dateAt`]="{ item }">
                            <div>{{ formatDate(item.dateAt) }} </div>
                        </template>
                        <template v-slot:[`item.AM`]="{ item }">
                          <v-chip
                              class="ma-1"
                              small
                              v-for="(obj, index) in item.AM"
                              :key="index"
                          >
                              {{ obj.firstName }}
                          </v-chip>
                        </template>
                      </v-data-table>
                    </td>

                    <td :colspan="headers.length" style="border:none;padding:20px;" v-else>
                        <v-data-table
                          :headers="overviewHeaders"
                          :items="item.clients"
                          class="elevation-1"
                          single-expand
                          :expanded.sync="expanded2"
                          :key="dataTableKey"
                          show-expand
                        >
                          <!-- <template v-slot:[`group.header`]="{items, isOpen, toggle, remove}">
                            <th colspan="9">
                              <v-icon @click="toggle"
                                >{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}
                              </v-icon>
                              {{ items[0].groupName }}
                              <v-icon @click="remove">mdi-close</v-icon>
                            </th>
                          </template> -->
                          <template v-slot:[`item.totalIOAmount`]="{ item }">
                              <v-chip class="ma-1" color="primary" small text-color="white">
                                <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                                <span>{{ item.totalIOAmount | thousandSeprator}}</span>
                              </v-chip>
                          </template>
                          <template v-slot:[`item.totalRevenue`]="{ item }">
                              <v-chip class="ma-1" color="green" small text-color="white">
                                <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                                <span>{{ item.totalRevenue | thousandSeprator}}</span>
                              </v-chip>
                          </template>

                          <template v-slot:[`item.totalCompletion`]="{ item }">
                              <div :style="{color: getColor(item.totalCompletion)}">{{ item.totalCompletion }} %</div>
                          </template>
                          <template v-slot:[`item.totalPayout`]="{ item }">
                            <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.totalPayout | thousandSeprator}}
                          </template>
                          <template v-slot:[`item.lastIODate`]="{ item }">
                              <div>{{ formatDate(item.lastIODate) }} </div>
                          </template>

                          <template v-slot:[`item.CO`]="{ item }">
                              <v-chip
                                  class="ma-1"
                                  small
                                  v-for="(obj, index) in item.CO"
                                  :key="index"
                              >
                                  {{ obj.firstName }}
                              </v-chip>
                          </template>
                          <template v-slot:expanded-item="{ headers, item }" style="box-shadow:none;">
                              <td :colspan="headers.length" style="border:none;padding:20px;">
                                  <v-data-table
                                    :headers="detailsHeaders"
                                    :items="item.campaigns"
                                    class="elevation-1"
                                    hide-default-footer
                                  >
                                    <template v-slot:[`item.IOAmount`]="{ item }">
                                      <span v-if="item.IOAmount === 0">N/A</span>
                                      <v-chip class="ma-1" color="primary" small text-color="white" v-else>
                                        <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                                        <span>{{ item.IOAmount | thousandSeprator}}</span>
                                      </v-chip>
                                    </template>
                                    <template v-slot:[`item.budget`]="{ item }">
                                      <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.budget | thousandSeprator}}
                                    </template>
                                    <template v-slot:[`item.payout`]="{ item }">
                                      <v-icon small class="currency">mdi-currency-usd</v-icon>{{ item.payout | thousandSeprator}}
                                    </template>
                                    <template v-slot:[`item.revenvue`]="{ item }">
                                        <v-chip class="ma-1" color="green" small text-color="white">
                                          <v-icon small left class="mr-0">mdi-currency-usd</v-icon>
                                          <span>{{ item.revenvue | thousandSeprator}}</span>
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item.completion`]="{ item }">
                                        <div :style="{color: getColor(item.completion)}">{{ item.completion }}</div>
                                    </template>
                                    <template v-slot:[`item.dateAt`]="{ item }">
                                        <div>{{ formatDate(item.dateAt) }} </div>
                                    </template>
                                    <template v-slot:[`item.AM`]="{ item }">
                                      <v-chip
                                          class="ma-1"
                                          small
                                          v-for="(obj, index) in item.AM"
                                          :key="index"
                                      >
                                          {{ obj.firstName }}
                                      </v-chip>
                                  </template>
                                  </v-data-table>
                              </td>
                          </template>
                        </v-data-table>
                    </td>
                  </template>
                </v-data-table>
          </v-col>
      </v-row>
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        loader="bars"
        background-color="#000"
        color="secondary"
        width.number="180"
        height.number="180"
      />
  </div>
</template>
<script>
import moment from 'moment'
import SpendHelper from '../DashboardComponents/SpendHelper'
import Loading from 'vue-loading-overlay'
// Components
export default {
  name: 'Summary_Of_Account',
  props: {
    filterUsers: {type: Array},
    userType: {type: String}
  },
  components: {
    Loading
  },
  data() {
    return {
      dataTableKey: 0,
      message: {
        show: false,
        text: '',
        type: 'info'
      },
      isLoading: false,
      overviewHeaders: [
        {
          'text': 'Client Name',
          'align': 'start',
          'value': 'name',
          'sortable': true,
          'groupable': false
        },
        {
          'text': 'Number Of IO',
          'align': 'center',
          'value': 'numberOfIOs',
          'sortable': true,
          'groupable': false
        },
        {
          'text': 'Total IO Amount',
          'align': 'center',
          'sortable': true,
          'groupable': false,
          'value': 'totalIOAmount'
        },
        {
          'text': 'Total Revenue Recognize',
          'align': 'center',
          'sortable': true,
          'groupable': false,
          'value': 'totalRevenue'
        },
        {
          'text': '% Completion',
          'align': 'center',
          'sortable': true,
          'groupable': false,
          'value': 'totalCompletion'
        },
        {
          'text': 'Amount Paid',
          'align': 'center',
          'sortable': true,
          'groupable': false,
          'value': 'totalPayout'
        },
        {
          'text': 'Date Of Last IO',
          'align': 'center',
          'sortable': true,
          'groupable': false,
          'value': 'lastIODate'
        },
        {
          'text': 'CC',
          'align': 'center',
          'sortable': true,
          'groupable': false,
          'value': 'CO'
        }
      ],
      overviewData: [],
      detailsHeaders: [
        {
          'text': 'IO Number',
          'align': 'start',
          'value': 'ioNumbers',
          'groupable': false
        },
        {
          'text': 'IO Amount',
          'align': 'center',
          'sortable': false,
          'value': 'IOAmount',
          'groupable': false
        },
        {
          'text': 'Amount Paid',
          'align': 'center',
          'sortable': false,
          'value': 'payout',
          'groupable': false
        },
        {
          'text': 'Campaign Name',
          'align': 'center',
          'sortable': false,
          'value': 'name',
          'groupable': false
        },
        {
          'text': 'Product Name',
          'align': 'center',
          'sortable': false,
          'value': 'ProductName',
          'groupable': false
        },
        {
          'text': 'Budget',
          'align': 'center',
          'sortable': false,
          'value': 'budget',
          'groupable': false
        },
        {
          'text': 'Revenue',
          'align': 'center',
          'sortable': false,
          'value': 'revenvue',
          'groupable': false
        },
        {
          'text': '% Completion',
          'align': 'center',
          'sortable': false,
          'value': 'completion',
          'groupable': false
        },
        {
          'text': 'Date',
          'align': 'center',
          'sortable': false,
          'value': 'dateAt',
          'groupable': false
        },
        {
          'text': 'AM',
          'align': 'center',
          'sortable': false,
          'value': 'AM'
        }
      ],
      expanded: [],
      filterItems: [],
      selectedFilter: ''
    }
  },
  async mounted() {
    this.getOverviewData({})
  },
  methods: {
    async getOverviewData(filter) {
      this.isLoading = true
      this.overviewData = await SpendHelper.getOverviewReportData(filter)
      this.isLoading = false
      // this.overviewData = this.overviewData.map(o => {
      //   o.groupName = o.groupName || 'No Group'
      //   return o
      // })
    },
    getColor (minusNumber) {
      if (minusNumber) {
        if (minusNumber.toString().indexOf('-') !== -1) return 'red'
      }
    },
    search() {
      let filter = Object.assign({}, {
        User: this.selectedFilter,
        userType: this.userType
      });
      this.getOverviewData(filter)
    },
    formatDate(value) {
      return moment(value).format('MMM-YYYY');
    }
  }
}
</script>
<style scoped>
.sub-title {
  font-size: 38px !important;
  font-weight: 300;
}
.currency {
  margin-top: -3px;
}

@font-face {
    font-family: WorkSans-Regular;
    src: url('/static/fonts/WorkSans-Regular.ttf');
}
@font-face {
    font-family: WorkSans-ExtraLight;
    src: url('/static/fonts/WorkSans-ExtraLight.ttf');
}
@font-face {
    font-family: WorkSans-SemiBold;
    src: url('/static/fonts/WorkSans-SemiBold.ttf');
}
@font-face {
    font-family: WorkSans-Medium;
    src: url('/static/fonts/WorkSans-Medium.ttf');
}
</style>



// WEBPACK FOOTER //
// summaryOfAccount.vue?468dafc6